module.exports = __webpack_public_path__ + "img/jianjie.08ce3c7c.png";